import { ErrorMessage, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as Yup from "yup";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import "../style.scss";
import { Card } from "react-bootstrap";
import { getSecurityDataSelector } from "../../../../../store/selector/cmsSelector";
import { getSecurityDataAction } from "../../../../App/actions";
import addSecurityDataAction from "../actions";

const validationSchema = Yup.object({
  contact_us: Yup.string().required("contact can not be empty"),
});

function ContactUsSection() {
  const dispatch = useDispatch();
  const securityData = useSelector(getSecurityDataSelector);
  const [contactUsEdit, setContactUsEdit] = useState(false);

  const initialState = {
    contact_us: securityData?.contact_us ? securityData?.contact_us : "",
  };

  const handleSubmit = (values: any) => {
    const formData = new FormData();
    formData.append("contact_us", values.contact_us);
    formData.append("request_type", "contact_us");
    dispatch(addSecurityDataAction(formData, setContactUsEdit));
  };

  useEffect(() => {
    dispatch(getSecurityDataAction());
  }, [dispatch]);

  return (
    <Formik enableReinitialize initialValues={initialState} validationSchema={validationSchema} onSubmit={handleSubmit}>
      {({ values, setFieldValue }) => {
        return (
          <Form>
            <Card>
              <Card.Header className="d-flex justify-content-between align-items-center">
                <h6 className={`mb-0 ${contactUsEdit ? "editTitle" : ""}`}>Contact Us</h6>
                {contactUsEdit ? (
                  <button className="btn btn-primary" type="submit">
                    Save <i className="fa-regular fa-floppy-disk ms-1" />
                  </button>
                ) : (
                  <span aria-hidden="true" onClick={() => setContactUsEdit(true)} className="btn btn-green">
                    Edit <i className="fa-regular fa-pen-to-square ms-1" />
                  </span>
                )}
              </Card.Header>
              <Card.Body>
                <CKEditor
                  editor={ClassicEditor}
                  data={values.contact_us}
                  name="contact_us"
                  className="ekEditorWrap"
                  readOnly={!contactUsEdit}
                  disabled={!contactUsEdit}
                  onChange={(_event: any, editor: any) => {
                    const data = editor.getData();
                    setFieldValue("contact_us", data);
                  }}
                />
                <ErrorMessage name="contact_us" className="errorMessage" component="div" />
              </Card.Body>
            </Card>
          </Form>
        );
      }}
    </Formik>
  );
}

export default ContactUsSection;
